import Vue from "vue";
import runtimeConfig from "@/runtimeConfig";
// axios
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import axios from "axios";
import store from "../store";
const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: runtimeConfig("VUE_APP_API_URL"),
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
});
axiosIns.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    const code = parseInt(error.response && error.response.status);
    let errorhandle = null;
    if (code == 422) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        Object.keys(error.response.data.errors).length
      ) {
        Object.keys(error.response.data.errors).map((key) => {
          if (
            error.response.data.errors[key][0].includes(
              "کاربری با این ایمیل یافت نشد"
            )
          ) {
            errorhandle = error;
          } else {
            Vue.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: error.response.data.errors[key][0],
                  icon: "CoffeeIcon",
                  variant: "danger",
                },
              },
              { position: "bottom-right" }
            );
          }
        });
        if (errorhandle) {
          return errorhandle;
        }
      } else {
        Vue.$toast(
          {
            component: ToastificationContent,
            props: {
              title: `مشکلی پیش آمده است.`,
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    }
    if (code == 404) {
      location.replace("/404");
    }
    if (code == 500 || code == 501 || code == 502) {
      Vue.$toast(
        {
          component: ToastificationContent,
          props: {
            title: `خطای سرور`,
            icon: "InfoIcon",
            variant: "danger",
          },
        },
        { position: "bottom-right" }
      );
      // location.replace("/404");
    }
    if (code == 401) {
      localStorage.removeItem("userData");
      store.dispatch("auth/setUserData", {});
      localStorage.removeItem("token");
      axiosIns.defaults.headers.common["Authorization"] = ``;
      location.replace("/login");
      Vue.$toast(
        {
          component: ToastificationContent,
          props: {
            title:
              "نشست شما منقضی شده است یا با دستگاه دیگری وارد حساب کاربری خود شده اید",
            icon: "EditIcon",
            variant: "danger",
          },
        },
        { timeout: 10000, position: "bottom-right" }
      );
    }
  }
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
